module.exports = __webpack_public_path__ + "img/proteger.f7f7d089.png";